module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/bot_agents.53aa780c.svg";